export const watch = {
  $route() {
    this.determineActive()
  }
}
